// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-detail-page-banner {
  background: linear-gradient(
    206deg,
    #e16432 1.93%,
    rgba(227, 108, 58, 0.68) 8.2%,
    #ffefc4 98.28%
  );
}
`, "",{"version":3,"sources":["webpack://./src/pages/requestEventDetailPage/banner/webRequestEventBanner/style.css"],"names":[],"mappings":"AAAA;EACE;;;;;GAKC;AACH","sourcesContent":[".request-detail-page-banner {\n  background: linear-gradient(\n    206deg,\n    #e16432 1.93%,\n    rgba(227, 108, 58, 0.68) 8.2%,\n    #ffefc4 98.28%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
